import type { AIAgent } from '../types/contracts';

export function AgentStatus({ agents }: { agents: AIAgent[] }) {
  return (
    <div className="rounded-xl bg-white border border-gray-100 px-4 py-3">
      <p className="text-[10px] font-black tracking-widest text-gray-400 mb-2">فريق الذكاء الاصطناعي</p>
      <ul className="space-y-1.5">
        {agents.map((a) => (
          <li key={a.id} className="flex items-center justify-between gap-2 text-xs">
            <span className="flex items-center gap-1.5 font-semibold text-gray-700">
              <span className={`w-1.5 h-1.5 rounded-full ${a.status === 'active' ? 'bg-emerald-500' : a.status === 'paused' ? 'bg-amber-400' : 'bg-gray-300'}`} />
              {a.name}
            </span>
            <span className="text-gray-400 capitalize">{a.status === 'active' ? 'نشط' : a.status === 'paused' ? 'متوقف' : a.status} · {a.handled_today} اليوم</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

/** Compact one-liner for the header. */
export function AgentStatusDot() {
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 border border-emerald-100 text-[11px] font-bold text-emerald-700">
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
      حالة المساعد: نشط
    </span>
  );
}
